import BaseAPI, { MAX_LIST_LIMIT } from "./BaseAPI";
import { getAPIUrlV2 } from "../apiConfig";
import { customerRoute } from "../routes";

export default class CustomerAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, customerRoute, "customer");
    }

    async List(params = {}) {
        return super.List({ limit: MAX_LIST_LIMIT, ...params });
    }

    async Create(data) {
        const result = await this._request("post", this._url(), data);
        this._emit("create", result.id);
        return result;
    }

    async MarkArchived(id) {
        const result = await this._request("post", `${getAPIUrlV2("customers/control")}/mark-archived?id=${id}`);
        this._emit("mark-archived", id);
        return result;
    }
}
